<template>
  <textarea
    :value="modelValue"
    @input="updateText"
    :rows="rows"
    :placeholder="placeholder"
    :required="required"
    :class="[full && 'w-full']"
    class="shadow-sm focus:ring-sky-blue block w-full sm:text-sm border-1 rounded-none"
  ></textarea>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue?: string;
    rows?: number;
    full?: boolean;
    required?: boolean;
    placeholder?: string;
  }>(),
  {
    modelValue: "",
    full: true,
  }
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const updateText = (event:Event) => emit("update:modelValue", (event?.target as HTMLInputElement).value);

</script>
